export const slugify = (text) => {
   if (!text) {
      return ""
   }
   return text
      .toString()
      .toLowerCase()                    // Convert to lowercase
      .trim()                           // Remove leading/trailing spaces
      .replace(/\s+/g, '-')             // Replace spaces with -
      .replace(/[^\w-]+/g, '')         // Remove all non-word chars
      .replace(/--+/g, '-');          // Replace multiple - with single -
}